import React from 'react';
import { Box, Container, Typography, Link, Stack, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const Footer = () => {
    return (
        <Box sx={{ bgcolor: '#0d1b2a', color: 'white', pt: 8, pb: 4, mt: 'auto' }}>
            <Container maxWidth="lg">
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
                    {/* Brand Section */}
                    <Box sx={{ flex: 1 }}>
                        <Stack spacing={2}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box sx={{ width: 40, height: 40, bgcolor: '#ffab00', borderRadius: 1 }} />
                                <Typography variant="h5" fontWeight="bold">SquareEdge</Typography>
                            </Box>
                            <Typography variant="body2" sx={{ opacity: 0.7, maxWidth: 300 }}>
                                A world-class school accounting system designed for precision, trust, and accountability.
                            </Typography>
                            <Stack direction="row" spacing={1}>
                                <IconButton sx={{ color: 'white', '&:hover': { color: '#ffab00' } }}><FacebookIcon /></IconButton>
                                <IconButton sx={{ color: 'white', '&:hover': { color: '#ffab00' } }}><TwitterIcon /></IconButton>
                                <IconButton sx={{ color: 'white', '&:hover': { color: '#ffab00' } }}><LinkedInIcon /></IconButton>
                                <IconButton sx={{ color: 'white', '&:hover': { color: '#ffab00' } }}><InstagramIcon /></IconButton>
                            </Stack>
                        </Stack>
                    </Box>

                    {/* Quick Links */}
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: '#ffab00' }}>Quick Links</Typography>
                        <Stack spacing={1}>
                            <Link href="#" color="inherit" underline="hover">Home</Link>
                            <Link href="#" color="inherit" underline="hover">About Us</Link>
                            <Link href="#" color="inherit" underline="hover">Features</Link>
                            <Link href="#" color="inherit" underline="hover">Contact</Link>
                            <Link href="/login" color="inherit" underline="hover">Admin Login</Link>
                        </Stack>
                    </Box>

                    {/* Contact Info */}
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: '#ffab00' }}>Contact Us</Typography>
                        <Stack spacing={2}>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <LocationOnIcon sx={{ color: '#ffab00' }} />
                                <Typography variant="body2">14 Argyle Rd, Avondale, Harare</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <EmailIcon sx={{ color: '#ffab00' }} />
                                <Link href="mailto:hello@squarredge.co.zw" color="inherit" underline="hover">hello@squarredge.co.zw</Link>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <PhoneIcon sx={{ color: '#ffab00' }} />
                                <Box>
                                    <Typography variant="body2">+263 868 800 7852</Typography>
                                    <Typography variant="body2">+263 772 690 161</Typography>
                                </Box>
                            </Box>
                        </Stack>
                    </Box>
                </Stack>

                <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', mt: 8, pt: 4, textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ opacity: 0.6 }}>
                        &copy; {new Date().getFullYear()} SquarEdge Tech. All rights reserved. | <Link href="https://www.squareedge.co.zw" color="inherit">www.squareedge.co.zw</Link>
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
